import React from 'react';
import ReviewComments from './ReviewComments';
import ReviewRatings from './ReviewRatings';
import classnames from 'classnames';
import requiresReview from './hocs/requiresReview';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { ReviewContextType, ReviewType } from '../../../propTypes';

/**
 * Renders the "review" part of the cover sheet, the comments and ratings.
 */
const ReviewCoverSheetReview = ({ contactId, review, reviewContext }) => {
  const { reviews } = reviewContext;

  return (<React.Fragment>
    {(reviews.length !== 1 || !review.editable) && <ul className="review-cover-sheet-readers nav nav-tabs">
      {reviews.map(rev => <li key={rev.id}
                              className={classnames({ active: review && rev.id === review.id })}>
        <Link to={`/contacts/${contactId}/reviews/${rev.id}`}>
          {rev.editable ? 'My Review' : rev.user_name}
        </Link>
      </li>)}
    </ul>}

    <React.Fragment>
      <div className="review-cover-sheet-items">
        <div className="row">
          <div className="col-24">
            <h2>Reader Comments</h2>
            {review.editable && <p>
              As you enter your comments on each section, they will be saved here, and you can come back to
              edit them at any point.</p>}

            <ReviewComments review={review} reviewContext={reviewContext}/>
          </div>
        </div>
      </div>

      <div className="review-cover-sheet-ratings">
        <div className="row">
          <div className="col-24">
            <h2>Reader Scores</h2>

            {review.editable && <p>
              When you have finished reading, you’ll be prompted to rate the applicant to complete your review. You
              can
              come back and edit these ratings at any point.
            </p>}

            <ReviewRatings review={review} schoolYearId={review.school_year_id}/>
          </div>
        </div>
      </div>
    </React.Fragment>
  </React.Fragment>);
};

ReviewCoverSheetReview.propTypes = {
  contactId: PropTypes.string.isRequired,
  review: ReviewType.isRequired,
  reviewContext: ReviewContextType.isRequired,
};

export default requiresReview(ReviewCoverSheetReview);
